import Scanner from "../components/Scanner";
import Footer from "../components/layout/Footer";
import Header from "../components/layout/Header";

export default function ScanPage() {
  return (
    <div className="App bg-gray-100 min-h-screen flex flex-col">
        <Header />
        <Scanner />
        <Footer />
    </div>
  );
}
